import styled from 'styled-components';

const ListingWrapper = styled.div`
    margin: 24px;
`;

export default ListingWrapper;
